<template>
  <div>
    <table class="table">
      <tbody>
      <tr>
        <td>
          Subtotal
        </td>
        <td>
          <span>R$ {{ subtotal }}</span>
        </td>
      </tr>
      <tr>
        <td>
          Desconto por cupom
        </td>
        <td>
          <span>R$ {{ formattedDiscount }}</span>
        </td>
      </tr>
      <tr>
        <td>
          Frete
          <small style="font-size: 65%">(prazo de entrega {{ deadline }} dias úteis)</small>

        </td>
        <td>
          <span>R$ {{ totalFreight }}</span>
        </td>
      </tr>
      <tr>
        <td>
          TOTAL
        </td>
        <td>
          R$ <span>{{ total }}</span>
        </td>
      </tr>
      </tbody>
    </table>

    <input v-if="zipCode" type="hidden" name="zip_code" :value="zipCode">
    <input v-if="freightType" type="hidden" name="freight_type" :value="freightType">
  </div>
</template>

<script>
  export default {
    name: 'table-order',

    props: {
      inProduction: Boolean,
    },

    created() {
      this.$root.$on('updateTotals', () => this.updateTotals());
    },

    mounted() {
      this.$root.$on('getCurrentTotal', () => this.sendCurrentTotal());

      this.$root.$on('updateFreight', (payload) => {
        this.freight = payload.total;
        this.deadline = payload.deadline;
        this.zipCode = payload.zipCode;
        this.freightType = payload.freightType;
        this.updateTotals();
      });

      this.$root.$on('updateDiscount', (payload) => {
        this.discount = payload.value;
        this.coupon = payload.coupon;
        $('#couponHidden').val(this.coupon);
      });

      this.isAuthenticated = !!window.User;
    },

    computed: {
      cart: {
        get() {
          return this.$store.getters['getCart'];
        },
        set(cart) {
          this.$store.commit('SET_CART', cart);
        }
      },
    },

    watch: {
      discount: function (discount) {
        $('#couponHidden').val(this.coupon);
        this.updateTotals();
      },
    },

    data: function () {
      return {
        freight: 0,
        discount: 0,
        coupon: null,
        total: '0,00',
        subtotal: '0,00',
        totalPapers: '0,00',
        totalThemes: '0,00',
        totalFreight: '0,00',
        totalLicenses: '0,00',
        totalSupports: '0,00',
        totalTemplates: '0,00',
        formattedDiscount: '0,00',
        isAuthenticated: false,
        deadline: 0,
        zipCode: undefined,
        freightType: undefined,
      };
    },

    methods: {
      updateTotals() {
        let data = {
          freight: this.freight,
          coupon: this.discount,
        };

        if (!this.isAuthenticate) {
          let vm = this;
          data.cart = vm.cart;
        }

        axios.post('/ajax/store/totals', data).then((response) => {
          let totalWithDiscount = this.parseValue(response.data.total) + this.discount;
          if (totalWithDiscount < this.discount) {
            this.$root.$emit('removeCoupon');
          } else {
            this.total = response.data.total;
            this.subtotal = response.data.subtotal;
            this.totalTemplates = response.data.templates;
            this.totalThemes = response.data.themes;
            this.totalLicenses = response.data.licenses;
            this.totalPapers = response.data.papers;
            this.totalSupports = response.data.supports;
            this.totalFreight = response.data.freight;
            this.formattedDiscount = response.data.discount;
          }
        }).catch((error) => {
          this.$root.gritter('Erro!', 'Houve um erro ao atualizar os valores', 'danger');
        });
      },

      parseValue(value) {
        return parseFloat(value.replace('.', '').replace(',', '.'));
      },

      sendCurrentTotal() {
        let currentTotal = this.parseValue(this.total) + this.discount;
        this.$root.$emit('currentTotal', currentTotal);
      },
    },
  };
</script>

<style scoped>
  .table-cart-total table {
    margin-bottom: 0;
  }

  .table-cart-total table tbody tr td {
    background-color: white;
    font-family: 'Montserrat';
    font-size: 20px;
    font-weight: 300;
  }

  .table-cart-total table tbody tr:last-of-type td {
    font-size: 20px;
    border-bottom: 0;
    border-radius: 0;
  }

  .table-cart-total table tbody tr td:last-of-type {
    text-align: right;
  }

  .table>tbody>tr>td {
    border: 0;
  }

  tr:first-child>td:nth-of-type(1) {
    border-top-left-radius: 6.79px !important;
  }

  tr:first-child>td:nth-of-type(2) {
    border-top-right-radius: 6.79px !important;
  }
</style>




// WEBPACK FOOTER //
// resources/assets/js/store/components/TableOrder.vue